import { useEffect, useRef, useState } from 'react'
import CreateButton from '../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton';
import CRUDTable from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable';
import CRUDTableHeader from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader';
import CRUDth from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth';
import EditButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/EditButton/EditButton';
import DeleteButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/DeleteButton/DeleteButton';
import ShortTextCell from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell';
import CRUDTableRow from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow';
import Modal from '../../../../Partials/Elements/Modal/Modal';
import CreateDivision from './CreateDivision';
import ViewDivision from './ViewDivision';
import useAxiosInstance from '../../../../../Utilities/Hooks/useAxiosInstance';
import DeleteItem from '../../../../Partials/Layouts/DeleteItem/DeleteItem';
import UpdateDivision from './UpdateDivision';
import { DIVISION_API } from '../../../../../Utilities/APIs/APIs';

import { useNavigate } from 'react-router-dom';
import CRUDButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/CRUDButton';
import { RiImage2Line } from 'react-icons/ri';

function Divisions() {

  const axiosInstance = useAxiosInstance()

  const [divisions, setDivisions] = useState(null)
  const screenHeaerRef = useRef()
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight)
  }, [screenHeaerRef]);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false)
  const [toggleFetch, setToggleFetch] = useState(false)

  const [targetID, setTargetID] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {

    async function fetchAndSetDivisions() {
      const { data } = await axiosInstance.get(DIVISION_API)
      setDivisions(data)
    }
    fetchAndSetDivisions()

  }, [toggleFetch, axiosInstance])

  function triggerFetch() {
    setToggleFetch(prevState => !prevState)
  }
  return (
    <>
      <div className='screen_header' ref={screenHeaerRef}>
        <h1 className='screen_heading'>Divisions ({divisions?.length}  in total)</h1>
        <CreateButton
          screenTopicSingular={'Division'}
          setShowCreateForm={setShowCreateForm}
        />
      </div>
      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th='Division' />
          <CRUDth th='Actions' />
        </CRUDTableHeader>
        <tbody>
          {
            divisions?.map(division =>
              <CRUDTableRow key={division._id}>
                <ShortTextCell text={division.name} />
                <td>
                  <div className="action_buttons_wrapper">
                    <div className="action_buttons">
                      {/* <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={division._id}
                        setTargetID={setTargetID}
                      /> */}

                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={division._id}
                        setTargetID={setTargetID}
                        tooltipName={"Edit"} 
                        tooltipContent={"Edit"}
                      />

                      <DeleteButton
                        setShowDeleteSection={setShowDeleteSection}
                        targetID={division._id}
                        setTargetID={setTargetID}
                        tooltipName={"Delete"} 
                        tooltipContent={"Delete"}
                        
                      />
                      <CRUDButton
                        handleClick={() => navigate('/main/districts/' + division._id)}
                        tooltipName={"District"} 
                        tooltipContent={"District"}
                      >
                        <RiImage2Line />
                      </CRUDButton>
                    </div>
                  </div>
                </td>
              </CRUDTableRow>

            )
          }
        </tbody>
      </CRUDTable>
      {
        showCreateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Create Division`}
          setShowModalContent={setShowCreateForm}
        >
          <CreateDivision
            triggerFetch={triggerFetch}
            setShowCreateForm={setShowCreateForm}
          />
        </Modal>
      }
      {
        showUpdateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Update Division`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateDivision
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={setShowUpdateForm}
          />
        </Modal>
      }
      {
        showViewSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`View Division`}
          setShowModalContent={setShowViewSection}
        >
          <ViewDivision
            targetID={targetID}
          />
        </Modal>
      }
      {
        showDeleteSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`Delete Division`}
          setShowModalContent={setShowDeleteSection}
        >
          <DeleteItem
            api={DIVISION_API}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowDeleteItem={setShowDeleteSection}
          />
        </Modal>
      }
    </>
  )
}

export default Divisions